import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { StyledSpan, StyledText1 } from "../styles";
import { Add } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getAtomProFileName, handleAtomProAttachmentClick } from "utils/attachments";
import UploadAttachmentModal from "../fya/UploadAttachmentModal";
import AttachmentDisplay from "../AttachmentDisplay";
import { useMutation, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import { deleteManualResponse } from "api/services/automation/income-tax";
import CreateNoticeResponse from "../fya/CreateNoticeResponse";
import { useConfirm } from "context/ConfirmDialog";
import Loader from "components/Loader";

const NoticeResponse = ({ responses }) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState<string | false>(false);
  const queryClient = useQueryClient();
  const [editItem, setEditItem] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const conform = useConfirm();

  // Function to handle accordion toggle

  const handleToggle = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const { mutate, isLoading } = useMutation(deleteManualResponse, {
    onSuccess: () => {
      snack.success("Notice Response Deleted");
      queryClient.invalidateQueries("e-proceeding-notice");
    },
    onError: (error) => {
      snack.error(handleError(error));
    },
  });

  const handleDelete = (item) => {
    conform({
      msg: "Are you sure you want to delete this notice response?",
      action: () => mutate({ id: item?.id }),
    });
  };
  const handleEdit = (item) => {
    setEditItem(item);
    setOpenEdit(true);
  };

  // if (isLoading) {
  //   return <Loader />;
  // }

  return (
    <>
      {responses?.map((item, index) => (
        <Accordion
          expanded={expanded === `panel${index}`}
          onChange={handleToggle(`panel${index}`)}
          key={index}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}bh-content`}
            id={`panel${index}bh-header`}
          >
            <Typography variant="h6">
              Response {index + 1},{" "}
              {item?.submittedOn ? moment(item?.submittedOn).format("DD MMM YYYY HH:mm") : "--"},{" "}
              {item?.responseType === "FR"
                ? "Full Response"
                : item?.responseType === "PR"
                  ? "Partial Response"
                  : "--"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" gap={2}>
              <Grid item xs={12} p={2}>
                {item?.createdType === "MANUAL" && (
                  <Box display="flex" justifyContent="flex-end" mb={2} gap={1}>
                    <Button onClick={() => handleDelete(item)} variant="outlined" color="error">
                      Delete
                    </Button>
                    <Button onClick={() => handleEdit(item)} variant="outlined" color="primary">
                      Edit
                    </Button>
                  </Box>
                )}

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      style={{
                        border: "1.5px solid #d1d1e0",
                        padding: "10px",
                        marginBottom: "10px",
                        borderRadius: "7px",
                      }}
                    >
                      <StyledText1 variant="h6" color="primary" mb={1}>
                        Response/Remarks
                      </StyledText1>
                      <StyledSpan>{item?.remarks ? item?.remarks : "--"}</StyledSpan>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      style={{
                        border: "1.5px solid #d1d1e0",
                        padding: "10px",
                        marginBottom: "10px",
                        borderRadius: "7px",
                      }}
                    >
                      <StyledText1 variant="h6" color="primary" mb={1}>
                        Remark Submission On
                      </StyledText1>
                      <StyledSpan>
                        {item?.submittedOn
                          ? moment(item?.submittedOn).format("DD MMM YYYY HH:mm")
                          : "--"}
                      </StyledSpan>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      style={{
                        border: "1.5px solid #d1d1e0",
                        padding: "10px",
                        marginBottom: "10px",
                        borderRadius: "7px",
                      }}
                    >
                      <StyledText1 variant="h6" color="primary" mb={1}>
                        Response Type
                      </StyledText1>
                      <StyledSpan>
                        {item?.responseType === "FR"
                          ? "Full Response"
                          : item?.responseType === "PR"
                            ? "Partial Response"
                            : "--"}
                      </StyledSpan>
                    </Box>
                  </Grid>

                  {item?.createdType === "MANUAL" && (
                    <>
                      <Button startIcon={<Add />} onClick={() => setOpen(item)} color="secondary">
                        Add Response Attachments
                      </Button>
                    </>
                  )}
                  <Grid item xs={12}>
                    {item?.storage && (
                      <Grid item xs={12}>
                        <AttachmentDisplay data={item?.storage} />
                      </Grid>
                    )}
                    <Grid container spacing={1}>
                      {item?.attachments && (
                        <>
                          <Box padding={1} sx={{ backgroundColor: "#F6F6F6" }}>
                            <Typography variant="subtitle2">Attachments</Typography>
                          </Box>
                          {item?.attachments.map((detail: any, index: number) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                              <Box display="flex" textAlign="left" alignItems="center">
                                <Typography style={{ padding: "3px", margin: "2px" }}>
                                  {index + 1}.
                                </Typography>
                                <div
                                  key={index}
                                  style={{
                                    cursor: "pointer",
                                    padding: "3px",
                                    margin: "2px",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                    color: "blue",
                                  }}
                                  onClick={() =>
                                    handleAtomProAttachmentClick(detail, item?.storageSystem)
                                  }
                                >
                                  {getAtomProFileName(detail, item?.storageSystem)}
                                </div>
                              </Box>
                            </Grid>
                          ))}
                        </>
                      )}
                    </Grid>
                    {expanded === `panel${index}` && (
                      <>
                        <UploadAttachmentModal
                          open={open}
                          setOpen={setOpen}
                          type="Response"
                          item={item}
                        />
                      </>
                    )}

                    <CreateNoticeResponse
                      open={openEdit}
                      setOpen={setOpenEdit}
                      isEdit={editItem !== null}
                      editItem={editItem}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default NoticeResponse;
